import React from 'react';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import TirumalaLandingPage from './components/TirumalaLandingPage';
import MantralayamLandingPage from './components/MantralayamLandingPage';

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', 'Inter', sans-serif",
  },
  palette: {
    primary: {
      main: '#5B2D8E',
      light: '#7B4BB3',
      dark: '#3E1D63',
    },
    secondary: {
      main: '#E8E0F0',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/bangalore-to-tirumala" element={<TirumalaLandingPage />} />
          <Route path="/bangalore-to-mantralayam" element={<MantralayamLandingPage />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
